import { render, staticRenderFns } from "./ToggleShippable.vue?vue&type=template&id=bec63e68&scoped=true"
import script from "./ToggleShippable.vue?vue&type=script&lang=js"
export * from "./ToggleShippable.vue?vue&type=script&lang=js"
import style0 from "./ToggleShippable.vue?vue&type=style&index=0&id=bec63e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec63e68",
  null
  
)

export default component.exports